(() => {
  const initUnavailableVariantToggles = (root = document) => {
    root.querySelectorAll('[data-pdp-unavailable-toggle]').forEach((toggle) => {
      if (toggle.dataset.pdpUnavailableReady === 'true') return;

      const fieldset = toggle.closest('fieldset[data-pdp-collapse-unavailable]');
      if (!fieldset) return;

      const selectedUnavailableOption = fieldset.querySelector('input[data-pdp-unavailable-input]:checked');
      const startsExpanded = Boolean(selectedUnavailableOption);
      fieldset.dataset.pdpCollapseUnavailable = startsExpanded ? 'false' : 'true';
      toggle.setAttribute('aria-expanded', String(startsExpanded));
      toggle.dataset.pdpUnavailableReady = 'true';

      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        fieldset.dataset.pdpCollapseUnavailable = String(expanded);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initUnavailableVariantToggles());
  } else {
    initUnavailableVariantToggles();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initUnavailableVariantToggles(event.target);
  });
})();
